export default __webpack_public_path__ + "static/media/pause.57e675a5.png";